import i18n from "@/services/i18";
import React from "react";
import { useTranslation } from "react-i18next";

type TypographyNumberProps = {
  value: number | string;
  className?: string;
  langOverride?: "fa" | "en";
};

export const convertToPersianDigits = (input: string | number): string => {
  const lang = i18n.language;
  const s = String(input);
  if (lang.startsWith("fa") || lang === "fa-IR") {
    const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
    return s.replace(/\d/g, (d) => persianDigits[+d]);
  }
  return s;
};
// @eslint-disable-next-line
export const convertToEnglishDigits = (str: string) =>
  str.replace(/[۰-۹]/g, (d) => String("۰۱۲۳۴۵۶۷۸۹".indexOf(d)));
export const TypographyNumber: React.FC<TypographyNumberProps> = ({
  value,
  className,
  langOverride,
}) => {
  const { i18n } = useTranslation();
  const lang = langOverride || i18n.language;

  const displayValue =
    lang.startsWith("fa") || lang === "fa-IR"
      ? convertToPersianDigits(value)
      : String(value);

  return <span className={className}>{displayValue}</span>;
};
